var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3558 24.8387L29.0763 6.50323H21.3085V3.49247C21.3085 1.56559 19.7429 0 17.8161 0H12.5623C10.6354 0 9.06982 1.56559 9.06982 3.49247V6.50323H1.30207L0.00745083 24.8387C-0.112979 26.5548 1.24186 28 2.95799 28H27.4053C29.1214 28 30.4763 26.5398 30.3558 24.8387ZM12.2311 3.49247C12.2311 3.31183 12.3816 3.16129 12.5623 3.16129H17.8161C17.9967 3.16129 18.1472 3.31183 18.1472 3.49247V6.44301H12.2311V3.49247ZM24.7709 9.66452L22.2419 17.6882H8.13648L5.60745 9.66452H24.7709ZM3.1838 24.8387L3.89132 14.7376L5.8182 20.8495H24.5601L26.487 14.7376L27.1945 24.8387H3.1838Z",
    fill: "#08A2AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBag);
export default __webpack_public_path__ + "static/media/ico-bag.3d29a58fcdfc5bea1f08e2b474b474f9.svg";
export { ForwardRef as ReactComponent };